import { render, staticRenderFns } from "./MyFreeDevisButton.vue?vue&type=template&id=2fbf4f88&scoped=true"
import script from "./MyFreeDevisButton.vue?vue&type=script&lang=js"
export * from "./MyFreeDevisButton.vue?vue&type=script&lang=js"
import style0 from "./MyFreeDevisButton.vue?vue&type=style&index=0&id=2fbf4f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf4f88",
  null
  
)

export default component.exports